// =============================================================================
// FILE:
// frontend/src/pms/task_execution/tabs/IssuesTab.js
// =============================================================================

import React, {
  useEffect,
  useState
} from "react";

import {
  Eye
} from "lucide-react";

import {

  getIssueHistory

} from "../services/taskMaterialRequestService";


// =============================================================================
// COMPONENT
// =============================================================================

export default function IssuesTab({

  task

}) {


  // ===========================================================================
  // STATE
  // ===========================================================================
  const [rows, setRows] =
    useState([]);


  const [loading, setLoading] =
    useState(false);


  // ===========================================================================
  // LOAD
  // ===========================================================================
  useEffect(() => {

    loadIssues();

  }, [task]);


  // ===========================================================================
  // LOAD ISSUES
  // ===========================================================================
  const loadIssues =
    async () => {

      try {

        setLoading(true);

        // ---------------------------------------------------------------------
        // TODO:
        // Replace with API integration
        // ---------------------------------------------------------------------

                // -------------------------------------------------------------
        // LIVE ISSUE HISTORY
        // -------------------------------------------------------------
        const response =
          await getIssueHistory(
            task?.id
          );


        if (response?.success) {

          setRows(
            response.data || []
          );

        } else {

          setRows([]);
        }

      } catch (err) {

        console.error(
          "Failed to load issues",
          err
        );

      } finally {

        setLoading(false);
      }
    };


  // ===========================================================================
  // VIEW MOVEMENT
  // ===========================================================================
  const handleViewMovement =
    (row) => {

      console.log(
        "View warehouse movement",
        row
      );

      // ---------------------------------------------------------------------
      // FUTURE:
      // Open Warehouse Movement Detail Drawer
      // ---------------------------------------------------------------------
    };


  // ===========================================================================
  // LOADING
  // ===========================================================================
  if (loading) {

    return (

      <div style={styles.loader}>

        Loading issues...

      </div>
    );
  }


  // ===========================================================================
  // EMPTY
  // ===========================================================================
  if (!rows || rows.length === 0) {

    return (

      <div style={styles.emptyState}>

        No issues found

      </div>
    );
  }


  // ===========================================================================
  // RENDER
  // ===========================================================================
  return (

    <div style={styles.container}>


      {/* ================================================================ */}
      {/* HEADER */}
      {/* ================================================================ */}
      <div style={styles.sectionHeader}>


        <div>

          <div style={styles.title}>

            Material Issues

          </div>


          <div style={styles.subtitle}>


            Physical material issue,
            warehouse movement,
            and inventory consumption tracking

          </div>

        </div>

      </div>


      {/* ================================================================ */}
      {/* GRID */}
      {/* ================================================================ */}
      <div style={styles.gridContainer}>


        {/* ============================================================ */}
        {/* HEADER */}
        {/* ============================================================ */}
        <div style={styles.headerRow}>


          <div style={styles.colIssue}>
            Issue No
          </div>


          <div style={styles.colDate}>
            Date
          </div>


          <div style={styles.colMaterial}>
            Material
          </div>


          <div style={styles.colQty}>
            Qty
          </div>


          <div style={styles.colMovement}>
            Movement
          </div>


          <div style={styles.colStatus}>
            Status
          </div>


          <div style={styles.colUser}>
            Issued By
          </div>


          <div style={styles.colAction}>
            Action
          </div>

        </div>


        {/* ============================================================ */}
        {/* BODY */}
        {/* ============================================================ */}
        {

          rows.map((row) => (

            <div
              key={row.id}
              style={styles.dataRow}
            >


              {/* ------------------------------------------------------ */}
              {/* ISSUE */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colIssue}>


                <div style={styles.issueNo}>


                  {row.issue_no}

                </div>

              </div>


              {/* ------------------------------------------------------ */}
              {/* DATE */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colDate}>


                <div style={styles.cellText}>


                  {row.issue_date}

                </div>

              </div>


              {/* ------------------------------------------------------ */}
              {/* MATERIAL */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colMaterial}>


                <div style={styles.materialCode}>


                  {row.material_code}

                </div>


                <div style={styles.materialDesc}>


                  {
                    row.material_description
                  }

                </div>

              </div>


              {/* ------------------------------------------------------ */}
              {/* QTY */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colQty}>


                <div style={styles.qtyValue}>


                  {row.issued_qty}

                  {" "}

                  {row.uom}

                </div>

              </div>


              {/* ------------------------------------------------------ */}
              {/* MOVEMENT */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colMovement}>


                <div style={styles.movementNo}>


                  {row.movement_no}

                </div>

              </div>


              {/* ------------------------------------------------------ */}
              {/* STATUS */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colStatus}>


                <span style={
                  getStatusStyle(
                    row.issue_status
                  )
                }>

                  {
                    formatStatus(
                      row.issue_status
                    )
                  }

                </span>

              </div>


              {/* ------------------------------------------------------ */}
              {/* USER */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colUser}>


                <div style={styles.cellText}>


                  {row.issued_by}

                </div>

              </div>


              {/* ------------------------------------------------------ */}
              {/* ACTION */}
              {/* ------------------------------------------------------ */}
              <div style={styles.colAction}>


                <button
                  style={styles.viewBtn}
                  onClick={() =>
                    handleViewMovement(row)
                  }
                >

                  <Eye size={14} />

                  View

                </button>

              </div>

            </div>
          ))
        }

      </div>

    </div>
  );
}


// =============================================================================
// HELPERS
// =============================================================================

function formatStatus(status) {

  if (!status) {
    return "-";
  }

  return status
    .replaceAll("_", " ");
}


function getStatusStyle(status) {

  switch (status) {

    case "ISSUED":

      return styles.statusGreen;

    case "PARTIALLY_ISSUED":

      return styles.statusOrange;

    default:

      return styles.statusGray;
  }
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  container: {

    display: "flex",

    flexDirection: "column"
  },

  sectionHeader: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 18,

    marginBottom: 18,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  title: {

    fontSize: 18,

    fontWeight: 700,

    color: "#111827"
  },

  subtitle: {

    marginTop: 6,

    fontSize: 13,

    color: "#6b7280"
  },

  gridContainer: {

    background: "#ffffff",

    borderRadius: 14,

    overflow: "hidden",

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  headerRow: {

    display: "flex",

    background: "#f3f4f6",

    borderBottom:
      "1px solid #e5e7eb",

    padding: "14px 16px",

    fontSize: 13,

    fontWeight: 700,

    color: "#374151"
  },

  dataRow: {

    display: "flex",

    alignItems: "center",

    padding: "16px",

    borderBottom:
      "1px solid #f3f4f6"
  },

  colIssue: {

    width: 180
  },

  issueNo: {

    fontSize: 13,

    fontWeight: 700,

    color: "#2563eb"
  },

  colDate: {

    width: 140
  },

  colMaterial: {

    width: 320
  },

  materialCode: {

    fontSize: 13,

    fontWeight: 700,

    color: "#2563eb"
  },

  materialDesc: {

    marginTop: 4,

    fontSize: 13,

    color: "#374151"
  },

  colQty: {

    width: 140,

    display: "flex",

    justifyContent: "center"
  },

  qtyValue: {

    fontSize: 14,

    fontWeight: 700,

    color: "#111827"
  },

  colMovement: {

    width: 180
  },

  movementNo: {

    fontSize: 13,

    fontWeight: 700,

    color: "#7c3aed"
  },

  colStatus: {

    width: 180,

    display: "flex",

    justifyContent: "center"
  },

  colUser: {

    flex: 1
  },

  cellText: {

    fontSize: 13,

    color: "#111827"
  },

  colAction: {

    width: 120,

    display: "flex",

    justifyContent: "center"
  },

  viewBtn: {

    height: 34,

    border: "none",

    background: "#2563eb",

    color: "#ffffff",

    borderRadius: 8,

    padding: "0 12px",

    display: "flex",

    alignItems: "center",

    gap: 6,

    cursor: "pointer",

    fontWeight: 600
  },

  statusGreen: {

    background: "#dcfce7",

    color: "#166534",

    padding: "6px 10px",

    borderRadius: 999,

    fontSize: 12,

    fontWeight: 700
  },

  statusOrange: {

    background: "#ffedd5",

    color: "#c2410c",

    padding: "6px 10px",

    borderRadius: 999,

    fontSize: 12,

    fontWeight: 700
  },

  statusGray: {

    background: "#e5e7eb",

    color: "#374151",

    padding: "6px 10px",

    borderRadius: 999,

    fontSize: 12,

    fontWeight: 700
  },

  loader: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 40,

    textAlign: "center"
  },

  emptyState: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 40,

    textAlign: "center",

    color: "#6b7280"
  }
};